import React, { useState, Fragment, useEffect } from "react";
//* Component Imports
import PrimaryCard from "./../../Components/Cards/PrimaryCard";
import RecentOrdersCard from "./../../Components/Cards/RecentOrdersCard";
import { Layout } from "./../../Layout/Layout";
import SecondaryCard from "./../../Components/Cards/SecondaryCard";
import Colors from "./../../Assets/Styles/Colors";
import DashboardServices from "../../Api/Dashboard/DashboardServices";
import { useNavigate } from "react-router-dom";
//* Chart Imports
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
//* MUI Imports
import { Box, Grid, IconButton, MenuItem, Select, Typography } from "@mui/material";
import clsx from "clsx";
import {
  BrandingWatermark,
  Group,
  Person4,
  Work,
  ContactMail,
  Groups,
  KeyboardArrowLeft
} from "@mui/icons-material";
import BreadCrumbs from "./../../Components/BreadCrumbs/BreadCrumbs";
import moment from "moment";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function Dashboard() {

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const handleChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const navigate = useNavigate();

  const [dStats, setDStats] = useState([]);
  const [blogCounts, setBlogCounts] = useState([]);
  const [loader, setLoader] = useState(true);
  let adLeakMergedArray;
  let adMeetMergedArray;
  let adReadMergedArray;
  let adGuruMergedArray;
  let adBookMergedArray;
  // Chart  Object
  const adBazaarOptions = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Month Wise Ads and Proposals",
        fontSize: "18px",
      },
    },
  };

  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const months = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11
  ];

  const getStats = async () => {
    try {
      const result = await DashboardServices.getStats();
      console.log(result);
      setDStats(result?.data)
    } catch (error) {
      console.log(error)
    }
  }

  const getBlogCounts = async () => {
    try {
      const result = await DashboardServices.getBlogCounts();
      console.log(result);
      setBlogCounts(result?.data)
    } catch (error) {
      console.log(error)
    }
  }

  const monthlyProposalsData = {
    // label: "Proposals",
    // data:
    //   dStats?.proposalsStatsByMonth?.map(
    //     (item) => {
    //       // if (item?._id == months[item?._id]) {
    //       //   return item._id == months[item?._id] && item?.totalProposals
    //       // }
    //       if (months[item?._id] == item?._id) {
    //         return months[item?._id] == item._id && item?.totalProposals
    //       }
    //     }
    //   ),
    // backgroundColor: Colors.skyBlue,
    // borderRadius: 6,
    label: "Proposals",
    data: Array.from({ length: 12 }, (_, index) => {
      const monthData = dStats?.proposalsStatsByMonth?.find(item => months[item._id] == index + 1);
      return monthData ? monthData.totalProposals : 0;
    }),
    backgroundColor: Colors.warning,
    borderRadius: 6,
  };

  const monthlyAdsData = {
    // label: "Ads",
    // data:
    //   dStats?.adsStatsByMonth?.map(
    //     (item, index) => {
    //       // if (item?._id == months[item?._id]) {
    //       //   return item._id == months[item?._id] && item?.totalAds
    //       // }
    //       if (months[item?._id] == item?._id) {
    //         return months[item?._id] == item._id && item?.totalAds
    //       }
    //     }
    //   ),
    // backgroundColor: Colors.primary,
    // borderRadius: 6,
    label: "Ads",
    data: Array.from({ length: 12 }, (_, index) => {
      const monthData = dStats?.adsStatsByMonth?.find(item => months[item._id] == index + 1);
      return monthData ? monthData.totalAds : 0;
    }),
    backgroundColor: Colors.notification,
    borderRadius: 6,
  };

  const adBazaarData = {
    labels,
    datasets: [monthlyProposalsData, monthlyAdsData],
  };

  if (blogCounts !== undefined && blogCounts !== null) {
    const adleakKeys = blogCounts?.countsByTypeAndMonth?.adleak;
    const adleakValues = blogCounts?.countsByTypeAndMonth?.adleak;

    if (adleakKeys && adleakValues) {
      const monthsValues = Object.entries(adleakKeys).map(([key, value]) => ({
        _id: parseInt(moment(key).format("M")),
        totalBlogs: value
      }));
      adLeakMergedArray = monthsValues;
    }
  }

  const adLeaksOptions = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Month Wise Adleaks",
        fontSize: "18px",
      },
    },
  };

  const monthlyAdleaksData = {
    label: "Adleaks",
    data: Array.from({ length: 12 }, (_, index) => {
      const monthData = adLeakMergedArray?.find(item => months[item._id] == index + 1);
      console.log("🚀 ~ data:Array.from ~ monthData:", monthData)
      return monthData ? monthData.totalBlogs : 0;
    }),
    backgroundColor: "orange",
    borderRadius: 6,
  };

  const adLeaksData = {
    labels,
    datasets: [monthlyAdleaksData],
  };

  if (blogCounts !== undefined && blogCounts !== null) {
    const admeetKeys = blogCounts?.countsByTypeAndMonth?.admeet;
    const admeetValues = blogCounts?.countsByTypeAndMonth?.admeet;

    if (admeetKeys && admeetValues) {
      const monthsValues = Object.entries(admeetKeys).map(([key, value]) => ({
        _id: parseInt(moment(key).format("M")),
        totalBlogs: value
      }));
      adMeetMergedArray = monthsValues;
    }
  }

  const adMeetOptions = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Month Wise Admeet",
        fontSize: "18px",
      },
    },
  };

  const monthlyAdmeetsData = {
    label: "Admeet",
    data: Array.from({ length: 12 }, (_, index) => {
      const monthData = adMeetMergedArray?.find(item => months[item._id] == index + 1);
      console.log("🚀 ~ data:Array.from ~ monthData:", monthData)
      return monthData ? monthData.totalBlogs : 0;
    }),
    backgroundColor: "skyblue",
    borderRadius: 6,
  };

  const adMeetsData = {
    labels,
    datasets: [monthlyAdmeetsData],
  };

  if (blogCounts !== undefined && blogCounts !== null) {
    const adreadKeys = blogCounts?.countsByTypeAndMonth?.adread;
    const adreadValues = blogCounts?.countsByTypeAndMonth?.adread;

    if (adreadKeys && adreadValues) {
      const monthsValues = Object.entries(adreadKeys).map(([key, value]) => ({
        _id: parseInt(moment(key).format("M")),
        totalBlogs: value
      }));
      adReadMergedArray = monthsValues;
    }
  };

  const adReadOptions = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Month Wise Adread",
        fontSize: "18px",
      },
    },
  };

  const monthlyAdReadData = {
    label: "Adread",
    data: Array.from({ length: 12 }, (_, index) => {
      const monthData = adReadMergedArray?.find(item => months[item._id] == index + 1);
      console.log("🚀 ~ data:Array.from ~ monthData:", monthData)
      return monthData ? monthData.totalBlogs : 0;
    }),
    backgroundColor: "maroon",
    borderRadius: 6,
  };

  const adReadData = {
    labels,
    datasets: [monthlyAdReadData],
  };

  if (blogCounts !== undefined && blogCounts !== null) {
    const adguruKeys = blogCounts?.countsByTypeAndMonth?.adguru;
    const adguruValues = blogCounts?.countsByTypeAndMonth?.adguru;

    if (adguruKeys && adguruValues) {
      const monthsValues = Object.entries(adguruKeys).map(([key, value]) => ({
        _id: parseInt(moment(key).format("M")),
        totalBlogs: value
      }));
      adGuruMergedArray = monthsValues;
    }
  }

  const adGuruOptions = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Month Wise Adguru",
        fontSize: "18px",
      },
    },
  };

  const monthlyAdGuruData = {
    label: "Adguru",
    data: Array.from({ length: 12 }, (_, index) => {
      const monthData = adGuruMergedArray?.find(item => months[item._id] == index + 1);
      console.log("🚀 ~ data:Array.from ~ monthData:", monthData)
      return monthData ? monthData.totalBlogs : 0;
    }),
    backgroundColor: "darkgray",
    borderRadius: 6,
  };

  const adGuruData = {
    labels,
    datasets: [monthlyAdGuruData],
  };

  if (blogCounts !== undefined && blogCounts !== null) {
    const adbooksKeys = blogCounts?.countsByTypeAndMonth?.adbook;
    const adbooksValues = blogCounts?.countsByTypeAndMonth?.adbook;

    if (adbooksKeys && adbooksValues) {
      const monthsValues = Object.entries(adbooksKeys).map(([key, value]) => ({
        _id: parseInt(moment(key).format("M")),
        totalBlogs: value
      }));
      adBookMergedArray = monthsValues;
    }
  }

  const adBooksOptions = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: "Month Wise Adbooks",
        fontSize: "18px",
      },
    },
  };

  const monthlyAdbooksData = {
    label: "Adbooks",
    data: Array.from({ length: 12 }, (_, index) => {
      const monthData = adBookMergedArray?.find(item => months[item._id] == index + 1);
      console.log("🚀 ~ data:Array.from ~ monthData:", monthData)
      return monthData ? monthData.totalBlogs : 0;
    }),
    backgroundColor: "yellow",
    borderRadius: 6,
  };

  const adBooksdata = {
    labels,
    datasets: [monthlyAdbooksData],
  };

  useEffect(() => {
    getStats();
    getBlogCounts();
  }, [])

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        borderRadius: "12px",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          background: Colors.primaryGradient,
          p: 2,
          borderRadius: "12px",
        }}
      >
        <Grid item xs={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <IconButton onClick={() => navigate(-1)}>
              <KeyboardArrowLeft sx={{ color: Colors.white }} />
            </IconButton>
            <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
              Dashboard
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <BreadCrumbs currentPage={["Dashboard"]} />
        </Grid>
      </Grid>
      <Grid
        container
        rowGap={"17px"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item xs={12} md={12}>
          <Box
            sx={{
              backgroundColor: Colors.white,
              p: 2,
              borderRadius: "12px",
              height: 350,
              position: "relative",
              boxShadow: "0px 0px 3px 2px #ef34343b"
            }}
          >
            {/* <Box
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                padding: "5px",
              }}
            >
              <Select
                sx={{
                  height: "40px",
                }}
                value={selectedYear}
                onChange={handleChange}
                label="Year"
              >
                {Array.from(
                  { length: currentYear - 2019 },
                  (_, index) => 2020 + index
                ).map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </Box> */}
            <Bar
              options={adBazaarOptions}
              data={adBazaarData}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={5.9}>
          <Box
            sx={{
              backgroundColor: Colors.white,
              p: 2,
              borderRadius: "12px",
              height: 350,
              position: "relative",
              boxShadow: "0px 0px 3px 2px #ef34343b"
            }}
          >
            <Bar
              options={adLeaksOptions}
              data={adLeaksData}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={5.9}>
          <Box
            sx={{
              backgroundColor: Colors.white,
              p: 2,
              borderRadius: "12px",
              height: 350,
              position: "relative",
              boxShadow: "0px 0px 3px 2px #ef34343b"
            }}
          >
            <Bar
              options={adMeetOptions}
              data={adMeetsData}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={5.9}>
          <Box
            sx={{
              backgroundColor: Colors.white,
              p: 2,
              borderRadius: "12px",
              height: 350,
              position: "relative",
              boxShadow: "0px 0px 3px 2px #ef34343b"
            }}
          >
            <Bar
              options={adReadOptions}
              data={adReadData}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={5.9}>
          <Box
            sx={{
              backgroundColor: Colors.white,
              p: 2,
              borderRadius: "12px",
              height: 350,
              position: "relative",
              boxShadow: "0px 0px 3px 2px #ef34343b"
            }}
          >
            <Bar
              options={adGuruOptions}
              data={adGuruData}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={5.9}>
          <Box
            sx={{
              backgroundColor: Colors.white,
              p: 2,
              borderRadius: "12px",
              height: 350,
              position: "relative",
              boxShadow: "0px 0px 3px 2px #ef34343b"
            }}
          >
            <Bar
              options={adBooksOptions}
              data={adBooksdata}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={5.9}>
          <RecentOrdersCard
            freelancer={dStats?.totalIndividuals}
            provider={dStats?.totalAgencies}
            seeker={dStats?.totalCompanies}
            jobs={dStats?.totalAds}
            proposals={dStats?.totalProposals}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default Dashboard;